/* tslint:disable */
/* eslint-disable */
/**
 * Private UI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: ${project.version}
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportForDeploymentProgressResponseStbGroupStats
 */
export interface ReportForDeploymentProgressResponseStbGroupStats {
    /**
     * 
     * @type {number}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    size: number;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    loaderVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    firmwareVersion: string;
    /**
     * 
     * @type {string}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    uiVersion: string;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    loaderSuccessCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    firmwareSuccessCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    uiSuccessCount?: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    connectedLast24HCount: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    notConnectedLast1MCount: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    notConnectedLast3MCount: number;
    /**
     * 
     * @type {number}
     * @memberof ReportForDeploymentProgressResponseStbGroupStats
     */
    notConnectedLast6MCount: number;
}

export function ReportForDeploymentProgressResponseStbGroupStatsFromJSON(json: any): ReportForDeploymentProgressResponseStbGroupStats {
    return ReportForDeploymentProgressResponseStbGroupStatsFromJSONTyped(json, false);
}

export function ReportForDeploymentProgressResponseStbGroupStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportForDeploymentProgressResponseStbGroupStats {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'size': json['size'],
        'loaderVersion': json['loaderVersion'],
        'firmwareVersion': json['firmwareVersion'],
        'uiVersion': json['uiVersion'],
        'loaderSuccessCount': !exists(json, 'loaderSuccessCount') ? undefined : json['loaderSuccessCount'],
        'firmwareSuccessCount': !exists(json, 'firmwareSuccessCount') ? undefined : json['firmwareSuccessCount'],
        'uiSuccessCount': !exists(json, 'uiSuccessCount') ? undefined : json['uiSuccessCount'],
        'connectedLast24HCount': json['connectedLast24HCount'],
        'notConnectedLast1MCount': json['notConnectedLast1MCount'],
        'notConnectedLast3MCount': json['notConnectedLast3MCount'],
        'notConnectedLast6MCount': json['notConnectedLast6MCount'],
    };
}

export function ReportForDeploymentProgressResponseStbGroupStatsToJSON(value?: ReportForDeploymentProgressResponseStbGroupStats | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'size': value.size,
        'loaderVersion': value.loaderVersion,
        'firmwareVersion': value.firmwareVersion,
        'uiVersion': value.uiVersion,
        'loaderSuccessCount': value.loaderSuccessCount,
        'firmwareSuccessCount': value.firmwareSuccessCount,
        'uiSuccessCount': value.uiSuccessCount,
        'connectedLast24HCount': value.connectedLast24HCount,
        'notConnectedLast1MCount': value.notConnectedLast1MCount,
        'notConnectedLast3MCount': value.notConnectedLast3MCount,
        'notConnectedLast6MCount': value.notConnectedLast6MCount,
    };
}

